export class ComplexityNew
{    	
    id:number;
    colorComplexity:String;
    dependency:String;
    colorComplexity1:String;
    edited: boolean=undefined;
    editedValue:boolean = undefined;
    editedCheck:String;
}